import R from 'ramda'

const findVersion = versionType => item => R.compose(
  R.when(R.isNil, R.always(null)),
  R.find(R.propEq('type', versionType)),
  R.prop('versions')
)(item)

export const getImageVersion = (item, versionType) => R.ifElse(
  R.isNil,
  R.always(null),
  findVersion(versionType)
)(item)

export const getImageVersionSrc = (item, versionType) => {
  const findVersionUrl = R.compose(
    R.ifElse(
      R.isNil,
      R.always(null),
      R.prop('url')
    ),
    findVersion(versionType)
  )
  return R.cond([
    [R.isNil, R.always(null)],
    [R.T, findVersionUrl]
  ])(item)
}

export const getImageStatus = item => R.ifElse(
  R.isNil,
  R.always(null),
  R.prop('status')
)(item)



// WEBPACK FOOTER //
// ./src/helpers/mediaItems.js